<template>
  <card-panel>
    <span slot="header-name">{{ labels.referFriend }}</span>
    <div slot="content">
      <span>{{ labels.referralLinkLabel }}</span>
      <div class="amount">
        <orange-token></orange-token>
        <span class="paragraph-l paragraph-orange paragraph-bold">{{ amount }}</span>
      </div>
      <div>
        <span class="refer-today-text">{{ labels.startReferringToday }}</span>
        <button
          class="button is-secondary is-rounded paragraph-m refer-a-friend"
          @click="goToRegisterAsRefer()">
          {{ labels.startReferring }}
        </button>
      </div>
    </div>
  </card-panel>
</template>

<script>

import CardPanel from 'top20common/components/card-panel/CardPanel';
import OrangeToken from 'top20common/components/icons/tokens/OrangeToken';
import TextDelimiter from 'top20common/components/text-blocks/TextDelimiter';
import currencies from 'top20common/distribution/services/currencies';
import redirects from 'top20common/distribution/services/redirects';
import commonUtils from 'top20common/distribution/utils';
import {mapGetters} from 'vuex';

import ReferByEmailPopupContainer from '@/common/popups/ReferByEmailPopupContainer';
import ReferCopyInput from '@/common/refer-invite/ReferCopyInput';

export default {
  created() {
    this.$store.dispatch('getReferralPotentialBonusAction', {action: 'refer'});
  },
  computed: {
    ...mapGetters(['minPotentialBonusState', 'maxPotentialBonusState', 'potentialBonusCurrencyState']),
    labels() {
      let referralLinkLabel = this.$gettext('A successful referral for a position on %{platformName} can earn up to:');
      return {
        referFriend: this.$gettext('refer a friend'),
        referralLinkLabel: this.$gettextInterpolate(referralLinkLabel, {platformName: this.$context.title}),
        startReferringToday: this.$gettext('Start referring today!'),
        startReferring: this.$gettext('Start referring')
      };
    },
    amount() {
      return currencies.getSimplifiedMoneyRange(
        this.minPotentialBonusState,
        this.maxPotentialBonusState,
        this.potentialBonusCurrencyState
      );
    }
  },
  methods: {
    goToRegisterAsRefer() {
      let queryParams = {action: 'refer'};
      if (this.$route.query.source) {
        queryParams.source = this.$route.query.source;
      }

      redirects.goToCandidateRegister(null, null, null, commonUtils.dictToQueryString(queryParams));
    }
  },
  components: {
    CardPanel,
    ReferCopyInput,
    ReferByEmailPopupContainer,
    OrangeToken,
    TextDelimiter
  }
};
</script>

<style lang="scss" scoped>
.amount {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 0 10px;

  span {
    padding-left: 10px;
  }
}

.refer-today-text {
  padding-top: 15px;
  display: inline-block;
}

.button.refer-a-friend {
  margin-top: 20px;
  width: 100%;
}
</style>
